import React from 'react';
import clsx from "clsx";
import ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties from './ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties';
import { useStyles } from '../ShowPackageCustomCategoryWeightRangeCostsButton.style';
import ShowText from '../../../Info/ShowText/ShowText';
import Currency from '../../../../entities/Currency';
import { CurrencyModule } from '../../../../util/Currency';
import ShowIntervalWithTitle from '../../../Info/ShowIntervalWithTitle/ShowIntervalWithTitle';
import { useI18nContext } from '../../../../contexts/I18nContext';

const ShowPackageCustomCategoryWeightRangeCostsButtonRowSmall: React.FC<ShowPackageCustomCategoryWeightRangeCostsButtonRowProperties> = ({
                                                                                        customCategoryWeinghtRangesPrices,
                                                                                        weightRange
                                                                                    }) => {

    const classes = useStyles();
    const i18n = useI18nContext();

    const packageSalePrice = customCategoryWeinghtRangesPrices.find(t => t.customCategoryWeightRangeId === weightRange.id);

    return (
        <div
            className={clsx(classes.show_money_price_info_container)}>
            <ShowIntervalWithTitle title={i18n.translate("WEIGHT_RANGES_RANGE")} from={weightRange.from} to={weightRange.to}/>
            <ShowText text={CurrencyModule.format(packageSalePrice?.salePrice ?? 0, Currency.DOLLAR)} title={i18n.translate("WEIGHT_RANGES_PRICE")}/>
        </div>
    )
}

export default ShowPackageCustomCategoryWeightRangeCostsButtonRowSmall;
